import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // cateSroll
  const cateContainer = document.querySelector(".page-cate-group");
  const activeLink = cateContainer?.querySelector(".page-group-link.is-active");

  if (cateContainer && activeLink) {
    // 容器與 active 元素的相對位置
    const containerRect = cateContainer.getBoundingClientRect();
    const activeRect = activeLink.getBoundingClientRect();

    // 計算 active 元素的中心相對於容器左邊的距離
    const offsetCenter =
      activeLink.offsetLeft +
      activeRect.width / 2 -
      containerRect.width / 2;

    // 平滑滾動
    cateContainer.scrollTo({
      left: offsetCenter,
      behavior: "smooth"
    });
  }

  var indexCases = new Swiper('#indexCases', {
    speed: 700,
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        slidesOffsetBefore: 25,
        slidesOffsetAfter: 25,
      },
      641: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: ".index-cases-prev",
      nextEl: ".index-cases-next",
    },
  });

  var indexBanner = new Swiper('#indexBanner', {
    autoplay: {
      delay: 3000,
    },
    slidesPerView: 1,
    loop: true,
    speed: 700,
    navigation: {
      prevEl: ".index-banner-prev",
      nextEl: ".index-banner-next",
    },
  });

  var productFiguresThumb = new Swiper("#productFiguresThumb", {
    spaceBetween: 5,
    slidesPerView: 8,
    freeMode: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      0: {
        spaceBetween: 3,
      },
      640: {
        spaceBetween: 5,
      },
    }
  });

  var productFigures = new Swiper('#productFigures', {
    slidesPerView: 1,
    speed: 700,
    navigation: {
      prevEl: ".figure-prev",
      nextEl: ".figure-next",
    },
    thumbs: {
      swiper: productFiguresThumb,
    },
  });

  var productFeatures = new Swiper('#productFeatures', {
    slidesPerView: 1,
    autoplay: { delay: 3000 },
    loop: true,
    speed: 800,
    pagination: { el: '.feature-pagination', clickable: true },
  });

  var relatedProducts = new Swiper('#relatedProducts', {
    speed: 700,
    spaceBetween: 10,
    slidesPerView: 2,
    breakpoints: {
      641: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1170: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    navigation: {
      prevEl: ".related-product-prev",
      nextEl: ".related-product-next",
    },
  });

  var companyTech = new Swiper('#companyTech', {
    slidesPerView: 1,
    autoplay: { delay: 3000 },
    loop: true,
    speed: 800,
    pagination: { el: '.company-tech-pagination', clickable: true },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 1170) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 1170) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 1170) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // 編輯器模版-收合區塊在前台預設為關閉狀態
  let $c_details = $('.c-details');
  if ( $c_details.length != 0 ) {
    $c_details.removeAttr('open');
  }

  // 關於佳捷-願景與使命 ESG
  const target = document.getElementById("js-esg-section");
  if (target) {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        target.classList.add("show");
        observer.unobserve(target);
      }
    });
    observer.observe(target);
  }

  // YT video
  const yt_video = document.querySelector('.yt-video');
  const yt_overlay = yt_video?.querySelector('.overlay');
  const yt_iframe = yt_video?.querySelector('#yt-iframe');

  if (yt_overlay && yt_iframe) {
    yt_overlay.addEventListener('click', () => {
      // 使用 postMessage 告訴 YouTube 播放
      yt_iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      yt_overlay.style.display = 'none';
    });
  }
});

